import { HttpError } from './http.error';

export class ServerError extends HttpError {
    constructor(public code: number, url: string, error: any) {
        super(url, error);
    }
}
